export default "__VITE_ASSET__DrShXt9M__"